<template>
  <!-- Estado vacío: el proyecto tiene pictogramas pero no hay diseño de parque. Si el
       contexto permite diseñar (canBuild), ofrece un CTA para armar el parque. -->
  <div class="absolute w-full" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">
    <div class="flex flex-col items-center text-center" style="width: 480px; margin: 0 auto; color: #0a131c">
      <!-- Icono arriba -->
      <div style="color: #c7c7d1">
        <b-icon icon="solar-panel" pack="fas" custom-size="fa-5x"></b-icon>
      </div>
      <!-- Texto -->
      <h3 class="font-light text-3xl mt-6">Sin parque fotovoltaico</h3>
      <p class="text-sm mt-2.5" style="color: #76767D">El proyecto tiene pictogramas asociados a actividades pero no cuenta con el diseño.</p>
      <!-- CTA -->
      <div v-if="canBuild" class="mt-8">
        <b-button type="is-primary" icon-left="pen-ruler" icon-pack="fas"
          @click="$emit('epc-build')">
          {{ $t('build_park') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerEmptyDesign",

  props: {
    // true = el contexto permite diseñar → se muestra el CTA "armar parque".
    canBuild: { type: Boolean, default: false },
  },
}
</script>
